export default __webpack_public_path__ + "static/anachrony-balthazaurus-scroll-71ba91add4c1feedb3dd4e8054d31c85.mp4";